import { useCookies } from "react-cookie";

// LoginPage.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import {
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import kwaterlogo from '../assets/kaquastextlogo.png';
import backgroundimg from '../assets/loginbackground.png';
import v1linklogo from '../assets/v1linklogo.png';
import v2linklogo from '../assets/v2linklogo.png';
import v3linklogo from '../assets/v3linklogo.png';
import v4linklogo from '../assets/v4linklogo.png';
import { useAuth } from '../context/AuthContext';
import { loginUser } from '../api/api';

const LoginPage = ({ setLoggedIn }) => {
  const navigate = useNavigate();
  const { handleLogin, isAuthenticated } = useAuth(); // AuthContext에서 가져옴
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');

  // ✅ Remember Me 쿠키/로컬스토리지에서 초기값 가져오기
  useEffect(() => {
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    if (rememberedEmail) {
      setEmail(rememberedEmail);
      setRememberMe(true);
    }
  }, []);

  // 이미 로그인 되어 있으면 바로 메인 페이지로 이동
  useEffect(() => {
    if (isAuthenticated) navigate('/MainPage');
  }, [isAuthenticated, navigate]);

  const onSubmit = async () => {
    const res = await handleLogin(email, password);
    if (res.isLoggedIn) {
      // Remember Me 저장
      if (rememberMe) localStorage.setItem('rememberedEmail', email);
      else localStorage.removeItem('rememberedEmail');

      navigate('/MainPage');
    } else {
      setError(res.message || '로그인 실패: 이메일 또는 비밀번호를 확인하세요.');
      setPassword('');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') onSubmit();
  };

  const openLink = (url) => window.open(url, '_blank');
 
  const handleSignUpClick = () => { navigate('/SignUpPage'); };
  

  


  return (
    <Container>
     
      <LinkBox>
        <LinkBtn
          onClick={() => window.open("http://dronemap.dromii.com/login", "_blank")}
        >
          <Logoimg src={v1linklogo} />
        </LinkBtn>
        <LinkBtn
          onClick={() => window.open("http://dronemap.dromii.com:3001/login", "_blank")}
        >
          <Logoimg src={v2linklogo} />
        </LinkBtn>
        <LinkBtn onClick={() => window.open("http://v4.dromii.com/", "_blank")}>
          <Logoimg src={v4linklogo} />
        </LinkBtn>
      </LinkBox>
      <LoginContainer>
        <Logo src={kwaterlogo} alt="logo" />
        <TextField
          id="input-with-icon-textfield"
          label="Email"
          name="email"
          type="email"
          size="large"
          required
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AccountCircle fontSize="inherit" />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
        <FormControl sx={{ my: 1 }} fullWidth variant="outlined">
          <InputLabel size="small" htmlFor="outlined-adornment-password">
            Password
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? "text" : "password"}
            name="password"
            size="Large"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown} // ✅ 엔터 키 감지
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((show) => !show)}
                  edge="end"
                  size="small"
                >
                  {showPassword ? (
                    <VisibilityOff fontSize="inherit" />
                  ) : (
                    <Visibility fontSize="inherit" />
                  )}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        <FormControlLabel
          control={
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
          }
          label="Remember me"
        />
         <HR />
        <SignButton
          type="button"
          variant="outlined"
          color="info"
          size="small"
          fullWidth
          onClick={onSubmit}
        >
          Log In
        </SignButton>
       
        <SignUpBox>
          <label style={{ marginRight: "10px" }}>Don't have account? </label>
          <label
            style={{
              color: "#5098EC",
              fontWeight: "600",
              textDecoration: "underline",
            }}
            onClick={handleSignUpClick}
          >
            Sign up
          </label>
        </SignUpBox>
        
      </LoginContainer>
      <ServiceBox>

            
            
            </ServiceBox>
    </Container>
  );
};

export default LoginPage;
const Container = styled.div`
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
width: 100vw;
height: 100vh;
background-image: url(${backgroundimg}); /* 배경 이미지 설정 */
background-size: cover; /* 배경 이미지를 컨테이너 크기에 맞춤 */
background-position: center; /* 배경 이미지 위치 */
background-repeat: no-repeat; /* 배경 이미지 반복 금지 */
`

const ContainerImg = styled.img`
width:100%;
height:100vh;
`;
const Logo = styled.img`
margin:20px;`;

const LoginContainer = styled.div`

  max-width: 400px;

  margin: 0 auto;
  padding:50px 25px;
  display: flex;
  flex-direction: column;
 
  background-color:#ffffff;

  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;



const LinkBox = styled.div`
position:absolute;
top:20px;
left:20px;
display:flex;
z-index:1000;
`;
const LinkBtn = styled.div`

width:76px;
height:38px;
font-size:15px;
border-radius:4px;
display:flex;
align-items: center;
justify-content: center;
margin-right:10px;
color:white;
@media screen  and (min-width:1920px){
  height:42px;


  }
  `;

  const Logoimg = styled.img`
  width:100%;
  `;

  const SignButton = styled.div`
  display:flex;
align-items: center;
justify-content: center;
background-color:#5098EC;
color:white;
height:50px;
border-radius:4px;
`;

  const SignUpBox = styled.div`
  margin-top:5px;
  display:flex;
  justify-content: center;
  `;


  const HR = styled.hr`
      
      border: 1px solid #d8d8d8;
      margin: 1.5vw;
  `;


  const ServiceBox = styled.div`

  margin-top:50px;
  display:flex;
  align-items: center;
  justify-content: center;
 
  p{
    font-size:15px;
    margin-right:10px;
  }
  a{
    color:#4169e1;
  }
  `;

